import React from "react";
import { useTranslation } from "react-i18next";

import Button from "shared/components/FormElements/Button";

const ItemHeader = ({ onClose, children }) => {
  const { t } = useTranslation();

  const controls = (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        columnGap: "10px",
        justifyContent: "space-between",
        flex: children ? "unset" : 1,
      }}
    >
      <Button type="button" size="small" danger onClick={onClose}>
        &#60; {t("close")}
      </Button>
    </div>
  );

  const content = (
    <div style={{ display: "flex", flexDirection: "row", columnGap: "20px", width: "100%", alignItems: "center" }}>
      {onClose && controls}
      {children && (
        <div style={{ flex: 1, display: "flex", flexWrap: "wrap", gap: "40px", alignItems: "center" }}>{children}</div>
      )}
    </div>
  );

  return (
    <div
      className="card horizontal-flex align-items-center justify-content-between"
      style={{ width: "100%", marginBottom: "0px", borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}
    >
      {content}
    </div>
  );
};

export default ItemHeader;
